"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modalHeader = void 0;
var modalHeader = {
  colors: {
    "default": {
      borderColor: function borderColor(get) {
        return get('colorScheme', 'weakBorder');
      }
    }
  },
  padding: {
    "default": '1rem'
  },
  border: function border(get) {
    return get('globals', 'border');
  },
  borderRadius: function borderRadius(get) {
    return get('globals', 'borderRadius');
  }
};
exports.modalHeader = modalHeader;